import compTable from "./compTable.vue";
import Vue from "vue";
Vue.component("compTable",compTable);
